import { render, staticRenderFns } from "./NotificationManager.vue?vue&type=template&id=6a469e81&scoped=true&"
import script from "./NotificationManager.vue?vue&type=script&lang=js&"
export * from "./NotificationManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a469e81",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disks/apps/api/foundation/dev/webapp/vue-project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6a469e81', component.options)
    } else {
      api.reload('6a469e81', component.options)
    }
    module.hot.accept("./NotificationManager.vue?vue&type=template&id=6a469e81&scoped=true&", function () {
      api.rerender('6a469e81', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/administration/NotificationManager.vue"
export default component.exports